// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3yyUS","description":"PatientConsentPreview_description__dvjKS"};